import axios from "axios";
import React, { useState } from "react";
import axiosInstance from "../../../axios";
import { Loading } from "../../Other/Loading";

const AddPageMeta = ({ setModal, title, editData, instructorId }) => {
  const [formValue, setFormValue] = useState({
    field_name: editData.field_name || "",
    field_type: editData.field_type || "textarea", // Default to textarea
    field_value: editData.field_value || "",
    page_id: editData.page_id || instructorId,
  });

  const [success, setSuccess] = useState(false);
  const [error, setError] = useState({});
  const [load, setLoad] = useState(false);

  const handleChange = (event) => {
    const { name, value, type } = event.target;
    setFormValue((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? event.target.checked : value,
    }));
  };

  const validate = () => {
    let error = {};
    if (!formValue.field_name) {
      error.field_name = "Please enter Field name";
    }
    if (!formValue.field_value) {
      error.field_value = "Please enter Field value";
    }
    if (!formValue.page_id) {
      error.page_id = "Please select a Page ID";
    }
    setError(error);
    return Object.keys(error).length === 0;
  };

  const handleSubmit = async () => {
    setLoad(true);

    if (validate()) {
      const url = editData.id ? "/admin/edit/meta" : "/admin/add/meta";
      const data = {
        id: editData?.id,
        field_name: formValue.field_name,
        field_type: formValue.field_type,
        field_value: formValue.field_value,
        page_id: instructorId,
      };

      try {
        const res = await axiosInstance.post("/page/pageMeta", data);
        if (res.data.success) {
          setSuccess(true);
          setTimeout(() => setModal(false), 2000); // Close after 2 seconds
        }
      } catch (err) {
        console.error("Error submitting meta data:", err);
      } finally {
        setLoad(false);
      }

    } else {
      setLoad(false);
    }
  };


  return (
    <div className="forms-width-55 add-page">
      <div className="dashboard-container-new padding-custom-dashboard-0">
        <p>{editData?.id ? `Edit ${title}` : `Add New ${title}`}</p>
      </div>
      <div className="form-content">
        {!success && (
          <>
            <div className="border-bottom-new-0">
              <p className="basic-form-01">Field Information</p>
            </div>
            <div className="dashboard-main my-3">
              <label className="labels-form w-[20%]">Field Name*</label>
              <div className="w-[100%] mx-auto">
                <input
                  className="inputs-form mx-auto"
                  name="field_name"
                  value={formValue.field_name}
                  onChange={handleChange}
                />
                {error?.field_name && (
                  <span className="error-text-new text-center">{error?.field_name}</span>
                )}
              </div>
            </div>
            <div className="dashboard-main my-3">
              <label className="labels-form w-[20%]">Field Type*</label>
              <div className="w-[100%] mx-auto">
                <select
                  className="inputs-form"
                  name="field_type"
                  value={formValue.field_type}
                  onChange={handleChange}
                >
                  <option value="textarea">Textarea</option>
                  <option value="file">File</option>
                </select>
              </div>
            </div>
            <div className="dashboard-main my-3">
              <label className="labels-form w-[20%]">Field Value*</label>
              <div className="w-[100%] mx-auto">
                {formValue.field_type === "textarea" ? (
                  <textarea
                    className="inputs-form"
                    name="field_value"
                    value={formValue.field_value}
                    onChange={handleChange}
                  />
                ) : (
                  <input
                    className="inputs-form"
                    type="file"
                    name="field_value"
                    onChange={(e) => setFormValue({ ...formValue, field_value: e.target.files[0].name })}
                  />
                )}
                {error?.field_value && (
                  <span className="error-text-new">{error?.field_value}</span>
                )}
              </div>
            </div>
            <div className="dashboard-main my-3">
              <label className="labels-form w-[20%]">Page ID*</label>
              <div className="w-[100%] mx-auto">
                <input
                  className="inputs-form"
                  name="page_id"
                  value={formValue.page_id}
                  onChange={handleChange}
                />
                {error?.page_id && (
                  <span className="error-text-new">{error?.page_id}</span>
                )}
              </div>
            </div>
            <div className="dashboard-main justify-flex-new">
              <div className="margin-top-new-01-0">
                {load ? (
                  <Loading />
                ) : (
                  <button className="export-btn" onClick={handleSubmit}>
                    {editData?.id ? "Update" : "Submit"}
                  </button>
                )}
              </div>
              <div className="margin-top-new-01-0">
                <button
                  className="lastmonth-btn-0"
                  onClick={() => setModal(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </>
        )}
        {success && (
          <div className="alert-title">
            <div className="status-message">
              <div className="status-title">
                <p>
                  {editData.id
                    ? `${title} has been successfully updated`
                    : `${title} has been successfully added`}
                </p>
              </div>
            </div>
            <div className="margin-top-new-01-0">
              <button
                className="lastmonth-btn-0"
                onClick={() => setModal(false)}
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AddPageMeta;